import React, { useEffect, useState, useContext } from "react";
import { Menu } from "../Menu";
import { MenuLateral } from "../MenuLateral";
import { useForm } from "../../../../../../hooks/useForm";
import { AppContext } from "../../../../Context/Context";
import Swal from "sweetalert2";

export const MisDatos = () => {
    const [state] = useContext(AppContext);
    const [info, setinfo] = useState(null);
    const [descripcion, setdescripcion] = useState(null);
    const [value, setvalue] = useState("Todos");

    useEffect(() => {
        fetch("/config_generales")
            .then(res => res.json())
            .then(result => {
                setinfo(result);
            });
    }, []);

    const id = atob(sessionStorage.getItem("dtpln"));
    let planes = null;
    let plan = null;
    let datos = null;
    let domicilio = null;
    let email = null;
    if (state.data !== null) {
        datos = state.data.Usuario.Datos;

        planes = datos.Planes.Plan;
        plan = planes.filter(plan => plan.Id === id)[0];
        const domicilios = state.data.Usuario.Datos.Domicilios.Domicilios;
        domicilio = domicilios.filter(
            domicilio => domicilio.Tipo === "Particular"
        )[0];
        if (domicilio == undefined) {
            domicilio = domicilios.filter(
                domicilio => domicilio.Tipo === "Comercial (FP)"
            )[0];
        }
        const emails = state.data.Usuario.Datos.Mails.Mails;
        email = emails.filter(email => email.Tipo === "Particular")[0];
        if (email == undefined) {
            email = emails.filter(email => email.Tipo === "Particular (FP)")[0];
        }
        if (email == undefined) {
            email = emails.filter(email => email.Tipo === "Laboral")[0];
        }
    }

    const [errorPassword, seterrorPassword] = useState(null);
    const [errorRepassword, seterrorRepassword] = useState(null);
    const documento = atob(sessionStorage.getItem("dtdc"));

    const [formValues, handleInputChange, reset] = useForm({
        password: "",
        repassword: ""
    });

    let { password, repassword } = formValues;

    const validatePasswordPolicy = (password, documento) => {
        if (!password) return "La contraseña es obligatoria";

        if (password.length < 12 || password.length > 15) {
            return "Debe tener entre 12 y 15 caracteres";
        }

        if (!/[A-Z]/.test(password)) {
            return "Debe incluir al menos una letra mayúscula";
        }

        if (!/[a-z]/.test(password)) {
            return "Debe incluir al menos una letra minúscula";
        }

        if (!/[0-9]/.test(password)) {
            return "Debe incluir al menos un número";
        }

        if (!/^[A-Za-z0-9$&*%?=]+$/.test(password)) {
            return "Contiene caracteres no permitidos";
        }

        if (documento && password.includes(documento)) {
            return "No debe incluir su CUIT / CUIL";
        }

        return null;
    };

    const validateRepassword = (password, repassword) => {
        if (!repassword) return "Debe repetir la contraseña";

        if (password !== repassword) {
            return "Las contraseñas no coinciden";
        }

        return null;
    };

    let handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }

        const passwordError = validatePasswordPolicy(password, documento);
        const repasswordError = validateRepassword(password, repassword);

        seterrorPassword(passwordError);
        seterrorRepassword(repasswordError);

        if (passwordError || repasswordError) {
            return;
        }

        Swal.fire({
            title: "Cambiando contraseña",
            html: "cargando...",
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: false,
            customClass: {
                loader: "colorSwal"
            },
            willOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const hashEndpoint = await (await fetch('/api/show_endpoints/wshasheatexto')).json();
            const hashRes = await fetch(
                `${hashEndpoint.url_base}${hashEndpoint.url_variable}?Password=${repassword}`,
                { cache: 'no-cache' }
            );
            const hashJson = await hashRes.json();

            const endpoint = await (await fetch('/api/show_endpoints/wscambiapassword')).json();
            const res = await fetch(
                `${endpoint.url_base}${endpoint.url_variable}?CUIT=${documento}&Token=${atob(sessionStorage.getItem("dttk"))}&Password=${hashJson.Hash}`,
                { cache: 'no-cache' }
            );
            const json = await res.json();

            Swal.close();
            reset();

            if (json.Resultado.ErrorCodigo === "00") {
                Swal.fire({
                    icon: "success",
                    title: "La password ha sido cambiada con éxito."
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: json.Resultado.ErrorDescripcion
                });
            }
        } catch (err) {
            console.log(err);
            reset();
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Intente nuevamente"
            });
        }
    };

    const isSubmitDisabled =
        !!errorPassword ||
        !!errorRepassword ||
        !password ||
        !repassword;

    return (
        <div>
            <Menu />
            <div className="wrap">
                <MenuLateral key={state.selectedPlan?.Id || "default-key"} />
                <div className="next-to-sidebar">
                    {datos !== null ? (
                        <div className="datos">
                            <div className="datos_mainDiv mt-doub">
                                <div className="datos_mainDiv--user">
                                    <p>Mis datos</p>
                                    <a>Para modificar tus datos personales, por favor comunícate con nuestro Centro de Atención al Cliente llamando al {info?.telefono_footer}</a>
                                </div>
                            </div>

                            {info !== null && info.recomendaciones_mi_plan && (
                                <div className="datos_totalWidthDivInfo py-half">
                                    <div className="datos_totalWidthDivInfo--div">
                                        <p>{info.recomendaciones_mi_plan}</p>
                                    </div>
                                </div>
                            )}

                            <div className="datos_totalWidthDiv">
                                <div className="datos_totalWidthDiv--div">
                                    <p>DATOS PERSONALES</p>
                                </div>
                            </div>
                            <div className="datos_mainDiv mt-0">
                                <div className="datos_mainDiv--solicitud">
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>TITULAR: </b>{" "}
                                            {` ${datos.Nombre} ${datos.Apellido}`}
                                        </p>
                                    </div>
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>TIPO DE DOCUMENTO:</b> CUIT
                                        </p>
                                    </div>
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>Nª DE CUIT:</b> {datos.Numero}
                                        </p>
                                    </div>
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>CONDICIÓN FISCAL:</b>{" "}
                                            {datos.CondicionFiscal}
                                        </p>
                                    </div>
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>ESTADO CIVIL:</b> {datos.EstadoCivil}
                                        </p>
                                    </div>
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>SEXO:</b> {datos.Sexo}
                                        </p>
                                    </div>
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>FECHA DE NACIMIENTO:</b>{" "}
                                            {datos.FechaNacimiento}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="datos_totalWidthDiv">
                                <div className="datos_totalWidthDiv--div">
                                    <p>domicilio de correspondencia</p>
                                </div>
                            </div>
                            <div className="datos_mainDiv mt-0">
                                <div className="datos_mainDiv--solicitud">
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>DIRECCIÓN:</b>
                                        </p>
                                        <p>{domicilio.Direccion}</p>
                                    </div>
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>LOCALIDAD:</b>
                                        </p>
                                        <p>{domicilio.Localidad}</p>
                                    </div>
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>PROVINCIA:</b>
                                        </p>
                                        <p>{domicilio.Provincia}</p>
                                    </div>
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>CÓDIGO POSTAL:</b>
                                        </p>
                                        <p>{domicilio.CP}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="datos_totalWidthDiv">
                                <div className="datos_totalWidthDiv--div">
                                    <p>teléfonos y email</p>
                                </div>
                            </div>
                            <div className="datos_mainDiv mt-0">
                                <div className="datos_mainDiv--solicitud">
                                    {datos.Telefonos.Telefonos.map(telefono => (
                                        <div
                                            className="datos_mainDiv--solicitud--div"
                                            key={telefono.Tipo}
                                        >
                                            <p>
                                                <b className="text-uppercase">
                                                    {telefono.Tipo}:
                                                </b>
                                            </p>
                                            <p>{`(${telefono.CodigoArea}) - ${telefono.Numero}`}</p>
                                        </div>
                                    ))}
                                    <div className="datos_mainDiv--solicitud--div">
                                        <p>
                                            <b>EMAIL:</b>
                                        </p>
                                        <p>{email.Mail}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="datos_totalWidthDiv">
                                <div className="datos_totalWidthDiv--div">
                                    <p>cambio de contraseña</p>
                                </div>
                            </div>
                            <div className="datos_mainDiv mt-0">
                                <div className="datos_mainDiv--form">
                                    <form onSubmit={handleSubmit}>
                                        <div>
                                            <input
                                                className={`${errorPassword ? "errorMsg" : ""}`}
                                                name="password"
                                                minLength={12}
                                                maxLength={15}
                                                autoComplete="off"
                                                value={password}
                                                placeholder="Nueva contraseña"
                                                type="password"
                                                onChange={(e) => {
                                                    seterrorPassword(null);
                                                    seterrorRepassword(null);
                                                    handleInputChange(e);
                                                }}
                                                onBlur={(e) => {
                                                    const error = validatePasswordPolicy(e.target.value, documento);
                                                    seterrorPassword(error);
                                                }}
                                            />
                                            <p
                                                className={`${errorPassword != null &&
                                                    errorPassword != ""
                                                    ? "errorMsg"
                                                    : ""
                                                    } `}
                                            >
                                                {errorPassword}
                                            </p>
                                        </div>
                                        <div>
                                            <input
                                                className={`${errorRepassword ? "errorMsg" : ""}`}
                                                name="repassword"
                                                minLength={12}
                                                maxLength={15}
                                                autoComplete="off"
                                                value={repassword}
                                                placeholder="Repita la contraseña"
                                                type="password"
                                                onChange={(e) => {
                                                    seterrorRepassword(null);
                                                    handleInputChange(e);
                                                }}
                                                onBlur={(e) => {
                                                    const error = validateRepassword(password, e.target.value);
                                                    seterrorRepassword(error);
                                                }}
                                            />
                                            <p
                                                className={`${errorRepassword != null &&
                                                    errorRepassword != ""
                                                    ? "errorMsg"
                                                    : ""
                                                    } `}
                                            >
                                                {errorRepassword}
                                            </p>
                                        </div>
                                        <div>
                                            <button
                                                type="submit"
                                                disabled={isSubmitDisabled}
                                                style={{
                                                    opacity: isSubmitDisabled ? 0.5 : 1,
                                                    cursor: isSubmitDisabled ? "not-allowed" : "pointer"
                                                }}
                                            >
                                                <p>CAMBIAR CONTRASEÑA</p>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {info !== null && info.contacto_gral_mi_plan && (
                                <div className="datos_totalWidthDivInfo">
                                    <div className="datos_totalWidthDivInfo--div">
                                        <p>{info.contacto_gral_mi_plan}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="spinner-loader w-100 d-flex justify-content-center">
                            <div
                                className="spinner-border text-bordo text-warning mt-dbhf mb-doub align-self-center"
                                role="status"
                            >
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
